import { Card, Grid2, Typography } from '@mui/material';
import ButtonComponent from '../ButtonComponent';
import React, { ReactNode } from 'react';
import Modal from '@mui/material/Modal';
import { backgroundColorDarkTheme } from '../../styles/global.styles';
import { Check, Close } from '@mui/icons-material';

interface ConfirmDeleteModalComponentProps {
  handleCancelDeletion: () => void;
  handleConfirmDeletion: () => void;
  isVisibleDeleteDialog: boolean;
  message: string | ReactNode;
  isLoading?: boolean;
  setIsVisibleDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
}

const ConfirmDeleteModalComponent: React.FC<
  ConfirmDeleteModalComponentProps
> = ({
  handleCancelDeletion,
  handleConfirmDeletion,
  isVisibleDeleteDialog,
  message,
  setIsVisibleDeleteDialog,
  title,
  isLoading,
}) => {
  return (
    <Modal
      open={isVisibleDeleteDialog}
      onClose={() => setIsVisibleDeleteDialog(false)}
    >
      <Card sx={style.modalStyle} color="primary">
        <Typography id="modal-modal-title" variant="h6">
          {title}
        </Typography>
        <Typography id="modal-modal-description" fontSize={15} sx={{ mt: 2 }}>
          {message}
        </Typography>
        <Grid2 container spacing={3}>
          <Grid2>
            <ButtonComponent
              loading={isLoading}
              onClick={handleConfirmDeletion}
              sx={{ mt: 3 }}
              startIcon={<Check />}
            >
              Confirmar
            </ButtonComponent>
          </Grid2>
          <Grid2>
            <ButtonComponent
              color="error"
              loading={isLoading}
              onClick={handleCancelDeletion}
              startIcon={<Close />}
              sx={{ mt: 3 }}
            >
              Cancelar
            </ButtonComponent>
          </Grid2>
        </Grid2>
      </Card>
    </Modal>
  );
};

const style = {
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    backgroundColor: backgroundColorDarkTheme,
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxWidth: '90vw',
    maxHeight: '80vh',
    overflow: 'auto',
    boxShadow: 24,
    p: 4,
  },
};

export default ConfirmDeleteModalComponent;
